import axios from 'axios'

const KIOSK_KEY = 'pain_kiosk'

export type KioskState = {
  machine_token: string
  machine: { id: number; codigo: string; nome: string; tipo: string; localizacao: string | null } | null
  operator_id: number | null
  operator_nome: string | null
  operator_pin: string | null
  turno_id: number | null
  turno_nome: string | null
}

export function loadKiosk(): KioskState {
  try {
    const raw = localStorage.getItem(KIOSK_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return {
    machine_token: '', machine: null,
    operator_id: null, operator_nome: null, operator_pin: null,
    turno_id: null, turno_nome: null,
  }
}

export function saveKiosk(s: Partial<KioskState>) {
  const cur = loadKiosk()
  const next = { ...cur, ...s }
  localStorage.setItem(KIOSK_KEY, JSON.stringify(next))
  return next
}

export function clearKiosk() {
  localStorage.removeItem(KIOSK_KEY)
}

export const kioskApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30000,
})

kioskApi.interceptors.request.use((config) => {
  const s = loadKiosk()
  if (s.machine_token) config.headers['X-Machine-Token'] = s.machine_token
  if (s.operator_id) config.headers['X-Operator-Id'] = String(s.operator_id)
  if (s.operator_pin) config.headers['X-Operator-Pin'] = s.operator_pin
  return config
})
